<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-center">
  <p-card [style]="{ width: '60rem' }">
    <ng-template pTemplate="header">
      <p-breadcrumb [model]="pageVars.breadcrumbItems">
        <ng-template let-item let-last="last" let-first="first" pTemplate="item">
          <ng-container *ngIf="!first">
            <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
            <div *ngIf="!item.routerLink" class="breadcrumb-current-item">
              {{ item.label }}
            </div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
    </ng-template>

    <div>
      <p-button label="New" [raised]="true" icon="fa fa-plus" size="small" (click)="gridNewRow()" data-testid="newItem"></p-button>
    </div>

    <p-table [value]="insects" dataKey="id" [expandedRowKeys]="expandedRows">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5rem"></th>
          <th>Scientific Name</th>
          <th>Other Names</th>
          <th>Active</th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-insect let-expanded="expanded">
        <tr>
          <td>
            <p-button
              type="button"
              pRipple
              [pRowToggler]="insect"
              [text]="true"
              [rounded]="true"
              [plain]="true"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
          </td>
          <td>{{ insect.scientificName }}</td>
          <td>{{ getOtherNames(insect) }}</td>
          <td>
            <p-toggleswitch
              [(ngModel)]="insect.isActive"
              (onChange)="onInsectStatusChange(insect)"
              attr.data-testid="insectsToggleEdit{{ insect.id }}" />
          </td>
          <td>
            <button
              pButton
              type="button"
              icon="fa fa-pencil"
              (click)="editRow(insect)"
              text
              rounded
              severity="secondary"
              [outlined]="true"
              attr.data-testid="editRow{{ insect.id }}"></button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-insect>
        <tr>
          <td colspan="6">
            <div class="pl-8">
              <p-table [value]="insect.insectVariants" dataKey="id">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Variant Type</th>
                    <th>Description</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-insectVariant>
                  <tr>
                    <td>{{ getVariantTypeName(insectVariant.variantTypeId) }}</td>
                    <td>{{ insectVariant.description }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="3">There are no order for this product yet.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<p-dialog
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="dialogVars.visible"
  [style]="{ width: '50rem' }"
  appendTo="body">
  <ng-template pTemplate="header">
    <h4>Insect Details</h4>
  </ng-template>

  <div class="flex align-content-center flex-wrap">
    <div class="flex align-items-center justify-content-center" style="font-weight: bold">Scientific Name:</div>
    <div class="flex align-items-center justify-content-center pl-2">
      <app-taxon-search [(taxon)]="taxon" (taxonChange)="onTaxonChange($event)" id="scientificName"></app-taxon-search>
    </div>
  </div>
  <div class="flex flex-row mt-2 align-items-center">
    <label for="othernames" style="padding-right: 1rem; font-weight: bold; min-width: 120px">Other Names:</label>
    <div style="display: flex; flex-wrap: wrap">
      <p-chip
        *ngFor="let insectSynonym of dialogVars.data.insectSynonyms"
        [label]="insectSynonym.name"
        [removable]="true"
        class="p-mr-2"
        (onRemove)="removeOtherNames(insectSynonym)">
        <ng-template pTemplate="removeicon">
          <span class="pi pi-times-circle" style="color: #ef4444; cursor: pointer"></span>
        </ng-template>
      </p-chip>
      <p-button icon="pi pi-plus-circle" text="true" [style]="{ height: '100%' }" (click)="addOtherNameShow()" data-testid="addOtherName" />
    </div>
  </div>
  <div class="flex">
    <label for="active" style="padding-right: 1rem; font-weight: bold">Active:</label>
    <p-toggleswitch [(ngModel)]="dialogVars.data.isActive" data-testid="newInsectActive" />
  </div>
  <hr />
  <div class="flex align-items-center justify-content-between">
    <div>
      <h4>Variants</h4>
    </div>
    <div>
      <p-button
        label="New"
        [raised]="true"
        icon="fa fa-plus"
        size="small"
        (click)="openVariantDialog()"
        [disabled]="pageVars.isEditing"
        data-testid="newVariantItem"></p-button>
    </div>
  </div>
  <p-table [value]="dialogVars.data.insectVariants" tableStyleClass="p-datatable-gridlines">
    <ng-template #header>
      <tr>
        <th>Variant Type</th>
        <th>Description</th>
        <th>Active</th>
      </tr>
    </ng-template>
    <ng-template #body let-insectVariant let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="insectVariant">
        <td>
          {{ getVariantTypeName(insectVariant.variantTypeId) }}
        </td>
        <td>
          <input
            pInputText
            type="text"
            [(ngModel)]="insectVariant.description"
            [style]="{ width: '100%' }"
            attr.data-testid="itemName{{ insectVariant.id }}" />
        </td>
        <td>
          <p-toggleswitch [(ngModel)]="insectVariant.isActive" data-testid="newInsectVariantActive" />
        </td>
      </tr>
    </ng-template>
  </p-table>
  <hr />
  <div class="flex align-items-center justify-content-between">
    <div>
      <h4>Growth Stage Details</h4>
    </div>
    <div>
      <p-button
        label="New"
        [raised]="true"
        icon="fa fa-plus"
        size="small"
        (click)="openGrowthStageDialog()"
        [disabled]="pageVars.isEditing"
        data-testid="newGrowthStage"></p-button>
    </div>
  </div>
  <p-table [value]="dialogVars.data.insectGrowthStages" tableStyleClass="p-datatable-gridlines">
    <ng-template #header>
      <tr>
        <th>Growth Stage</th>
        <th>Degree Days</th>
        <th>Image</th>
        <th>Active</th>
      </tr>
    </ng-template>
    <ng-template #body let-growthStage let-editing="editing" let-ri="rowIndex">
      <tr>
        <td>
          {{ getGrowthStagename(growthStage.growthStageId) }}
          <div *ngIf="!isGrowthStageTypeActive(growthStage.growthStageId)" class="flex w-full text-red-500 text-xs">Inactive</div>
        </td>
        <td>
          <p-inputnumber
            [(ngModel)]="growthStage.degreeDays"
            class="w-full"
            inputId="degreeDays"
            mode="decimal"
            [useGrouping]="false"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
            data-testid="degreeDays" />
        </td>
        <td>
          <span *ngIf="isFetchingImage && growthStage.imageUrl === undefined">
            <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
            Fetching image...
          </span>
          <span *ngIf="growthStage.imageUrl !== '' && growthStage.imageUrl !== undefined && growthStage.uploadId !== undefined">
            <p-image width="150" height="100" [src]="growthStage.imageUrl"></p-image>
            <span style="vertical-align: top">
              <p-button
                icon="fa fa-trash"
                severity="danger"
                outlined
                class="p-button-outlined ml-2 mr-0"
                (click)="deleteImage(growthStage, ri)"
                pTooltip="Delete Image"
                tooltipPosition="top"></p-button>
            </span>
          </span>
          <span *ngIf="growthStage.imageUrl === '' || growthStage.uploadId === undefined">
            <p-fileUpload
              name="Stage Growth Image"
              accept="image/*"
              maxFileSize="10000000"
              auto="true"
              [customUpload]="true"
              [multiple]="false"
              chooseLabel="Add Image"
              (uploadHandler)="onFileUpload($event, ri)"
              (onError)="onFileUploadError($event)"
              #fileUploaderEditing>
            </p-fileUpload>
          </span>
        </td>
        <td>
          <p-toggleswitch
            [(ngModel)]="growthStage.isActive"
            [disabled]="!isGrowthStageTypeActive(growthStage.growthStageId)"
            data-testid="growthStageActive" />
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        (click)="createDlgCancel()"
        data-testid="newItemCancel" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        (click)="createDlgSave()"
        [disabled]="!dialogIsValid()"
        data-testid="newItemSave" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="New Synonym"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="displayOtherNameDialog"
  [style]="{ width: '25rem' }"
  appendTo="body">
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on">
      <label for="name">Synonym</label>
      <input pInputText id="name" class="w-full" autocomplete="off" [(ngModel)]="newSynonym" data-testid="newSynonymName" />
    </p-floatlabel>
  </div>

  <div class="flex justify-content-between gap-2">
    <p-button
      label="Cancel"
      icon="fa fa-times"
      severity="danger"
      size="small"
      [raised]="true"
      (click)="createOtherNamesDlgCancel()"
      data-testid="newOtherNameCancel" />
    <p-button
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="createOtherNamesDlgSave()"
      [disabled]="!otherNamesDialogIsValid()"
      data-testid="newOtherNameSave" />
  </div>
</p-dialog>

<p-dialog
  header="New Variant"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="displayVariantDialog"
  [style]="{ width: '25rem' }"
  appendTo="body">
  <div class="mt-2">
    <p-floatlabel class="w-full" variant="on">
      <p-select
        [(ngModel)]="newInsectVariant.variantTypeId"
        [options]="variantTypesCopy"
        optionLabel="name"
        optionValue="id"
        data-testid="variantTypes"
        inputId="variantType"
        styleClass="w-full"
        appendTo="body" />
      <label for="variantType">Variant Type</label>
    </p-floatlabel>
  </div>
  <div class="mt-2">
    <p-floatlabel class="w-full" variant="on">
      <input
        pInputText
        id="name"
        class="w-full"
        autocomplete="off"
        [(ngModel)]="newInsectVariant.description"
        data-testid="description"
        inputId="variantDescription" />
      <label for="variantDescription">Description</label>
    </p-floatlabel>
  </div>
  <div class="flex mt-2">
    <label for="active" style="padding-right: 1rem; font-weight: bold">Active:</label>
    <p-toggleswitch [(ngModel)]="newInsectVariant.isActive" data-testid="active" />
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        (click)="createVariantDlgCancel()"
        data-testid="newVariantCancel" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        (click)="createVariantDlgSave()"
        [disabled]="!variantDlgValid()"
        data-testid="newVariantSave" />
    </div>
  </ng-template>

  <!-- <div class="mb-4">
    <p-floatlabel class="mt-1" variant="on">
      <label for="name" style="padding-bottom: 18px">Variant Type</label>
      <p-select
        [(ngModel)]="newInsectVariant.variantTypeId"
        [options]="variantTypesCopy"
        [style]="{ width: '100%' }"
        optionLabel="name"
        optionValue="id"
        data-testid="variantTypes"
        appendTo="body"></p-select>
    </p-floatlabel>
  </div>
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on">
      <label for="name">Description</label>
      <input pInputText id="name" class="w-full" autocomplete="off" [(ngModel)]="newInsectVariant.description" data-testid="description" />
    </p-floatlabel>
  </div>
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on"> Active : <p-toggleswitch [(ngModel)]="newInsectVariant.isActive" data-testid="active" /> </p-floatlabel>
  </div>

  <div class="flex justify-content-between gap-2">
    <p-button
      label="Cancel"
      icon="fa fa-times"
      severity="danger"
      size="small"
      [raised]="true"
      (click)="createVariantDlgCancel()"
      data-testid="newVariantCancel" />
    <p-button
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="createVariantDlgSave()"
      [disabled]="!variantDlgValid()"
      data-testid="newVariantSave" />
  </div> -->
</p-dialog>

<p-dialog
  header="New Growth Stage"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="displayGrowthStageDialog"
  [style]="{ width: '25rem' }"
  appendTo="body">
  <div class="mt-2">
    <p-floatlabel class="w-full" variant="on">
      <p-select
        [(ngModel)]="newGrowthStage.growthStageId"
        [options]="growthStagesCopy"
        optionLabel="name"
        optionValue="id"
        data-testid="growthStages"
        inputId="growthStage"
        styleClass="w-full"
        appendTo="body" />
      <label for="growthStage">Growth Stage</label>
    </p-floatlabel>
  </div>
  <div class="mt-2">
    <p-floatlabel class="w-full" variant="on">
      <p-inputnumber
        [(ngModel)]="newGrowthStage.degreeDays"
        [useGrouping]="false"
        class="w-full"
        inputId="degreeDays"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="3"
        data-testid="degreeDays" />
      <label for="degreeDays">Degree Days</label>
    </p-floatlabel>
  </div>
  <div class="mt-2">
    <p-floatlabel class="mt-1" variant="on">
      <p-fileUpload
        name="Stage Growth Image"
        accept="image/*"
        maxFileSize="10000000"
        auto="true"
        [customUpload]="true"
        [multiple]="false"
        chooseLabel="Add Image"
        (uploadHandler)="onFileUpload($event)"
        (onError)="onFileUploadError($event)"
        #fileUploader>
      </p-fileUpload>
      <span *ngIf="isFetchingImage && newGrowthStage.imageUrl === undefined">
        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
        Fetching image...
      </span>
    </p-floatlabel>
  </div>
  <div class="flex mt-2">
    <label for="active" style="padding-right: 1rem; font-weight: bold">Active:</label>
    <p-toggleswitch [(ngModel)]="newGrowthStage.isActive" data-testid="active" />
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        [disabled]="isFetchingImage"
        (click)="createGrowthStageDlgCancel()"
        data-testid="newGrowthStageCancel" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        (click)="createGrowthStageDlgSave()"
        [disabled]="!growthStageDlgValid()"
        data-testid="newGrowthStageSave" />
    </div>
  </ng-template>

  <!-- <div class="mb-3" style="padding-top: 1rem">
    <p-floatlabel class="mt-1" variant="on">
      <label for="name" style="padding-bottom: 18px">Growth Stage</label>
      <p-select
        id="name"
        [(ngModel)]="newGrowthStage.growthStageId"
        [options]="growthStagesCopy"
        [style]="{ width: '100%' }"
        optionLabel="name"
        optionValue="id"
        data-testid="growthStages"
        appendTo="body"></p-select>
    </p-floatlabel>
  </div>
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on">
      <label for="degreeDays" style="padding-bottom: 18px">Degree Days</label>
      <p-inputnumber
        [(ngModel)]="newGrowthStage.degreeDays"
        [useGrouping]="false"
        class="w-full"
        inputId="degreeDays"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="3"
        data-testid="degreeDays" />
    </p-floatlabel>
  </div>
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on">
      <p-fileUpload
        name="Stage Growth Image"
        accept="image/*"
        maxFileSize="10000000"
        auto="true"
        [customUpload]="true"
        [multiple]="false"
        chooseLabel="Add Image"
        (uploadHandler)="onFileUpload($event)"
        (onError)="onFileUploadError($event)"
        #fileUploader>
      </p-fileUpload>
      <span *ngIf="isFetchingImage && newGrowthStage.imageUrl === undefined">
        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
        Fetching image...
      </span>
    </p-floatlabel>
  </div>
  <div class="mb-3">
    <p-floatlabel class="mt-1" variant="on"> Active : <p-toggleswitch [(ngModel)]="newGrowthStage.isActive" data-testid="active" /> </p-floatlabel>
  </div>

  <div class="flex justify-content-between gap-2">
    <p-button
      label="Cancel"
      icon="fa fa-times"
      severity="danger"
      size="small"
      [raised]="true"
      [disabled]="isFetchingImage"
      (click)="createGrowthStageDlgCancel()"
      data-testid="newGrowthStageCancel" />
    <p-button
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="createGrowthStageDlgSave()"
      [disabled]="!growthStageDlgValid()"
      data-testid="newGrowthStageSave" />
  </div> -->
</p-dialog>

<app-unsaved-changes-dialog [(visible)]="pageVars.showUnsavedChangesDialog" (decision)="onDialogConfirm($event)"> </app-unsaved-changes-dialog>

<app-processing [visible]="!pageVars.isReady"></app-processing>
